import React, { useState, useEffect } from 'react';
import './endcap.scss';
import { CountdownTimer } from '@thd-olt-component-react/countdown-timer';
import classNames from 'classnames';
import { HeaderSectionPropType, HeaderSectionDefaultPropType } from './Helper';

const HeaderSection = ({
  header,
  start,
  end,
  bannerImage,
  mobileAppBannerImg,
  headerLinkText,
  headerLinkUrl,
  timerDuration,
  badgeUrl,
  channel,
  timer,
  subHeader
}) => {

  const headerClasses = classNames(
    'header-section__title-text',
    { 'header-section__title-text--with-subheader': subHeader },
  );
  const timerClasses = classNames(
    'title-wrapper__countdown-wrapper',
    { 'title-wrapper__countdown-wrapper--no-timer': timer === null },
  );

  const widgetClasses = classNames(
    'widget-section title-section',
    { 'widget-section title-section--no-banner': bannerImage === null },
  );

  return (
    <div className="title-wrapper">
      { bannerImage
        && (
          <div className="title-banner">
            <img src={bannerImage} alt="" width="200px" height="400px" />
          </div>
        )}
      <div className={widgetClasses}>
        <div className="header-section">
          <div className={headerClasses}>
            <div>{ header } </div>
          </div>
          <div className="header-link">
            <a className="shop-all" href={headerLinkUrl}>
              { headerLinkText }
            </a>
          </div>
        </div>
        <div className="subheader-section">
          <div>{subHeader}</div>
        </div>
      </div>

      <div className={timerClasses}>
        <CountdownTimer
          onRemove={() => {}}
          classes="countdown-timer__wrapper--modifier"
          endDate={end}
          shouldUseMessagingString
          shouldUseClockDisplay
          shouldIncludeSvg
          shouldUseDateDisplay
          shouldUseDaysLeftDisplay
          shouldUseBlock
          timebombThreshold={parseFloat(timer?.timeBombThreshold)}
          daysLeftThreshold={parseFloat(timer?.daysLeftThreshold)}
          dateDisplayThreshold={parseFloat(timer?.dateDisplayThreshold)}
          customMessagingString={timer?.message}
        />
      </div>
    </div>
  );
};

HeaderSection.propTypes = HeaderSectionPropType;
HeaderSection.defaultProps = HeaderSectionDefaultPropType;

export { HeaderSection };
